import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'change-user-password-page';
export const useChangeUserPasswordPageTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns);

export const ruRu = {
  [ns]: {
    title: 'Сброс пароля',
    password: {
      label: 'Новый пароль',
      required: 'Введите новый пароль',
    },
    password_confirmation: {
      label: 'Повторите новый пароль',
      required: 'Повторите новый пароль',
    },
    submit: 'Установить',
    success: 'Пароль успешно изменён',
    error: {
      passwords_mismatch: 'Указанные значения не совпадают',
      reset_expired: 'Время для сброса пароля истекло, необходимо запросить ссылку на сброс пароля заново.',
      password_not_changed: 'Не удалось установить пароль',
    },
  },
};

export const en = {
  [ns]: {
    title: 'Password reset',
    password: {
      label: 'New password',
      required: 'Enter a new password',
    },
    password_confirmation: {
      label: 'Repeat new password',
      required: 'Repeat the new password',
    },
    submit: 'Set',
    success: 'Password changed successfully',
    error: {
      passwords_mismatch: 'The specified values do not match',
      reset_expired: 'The password reset time has expired. Request a password reset link again.',
      password_not_changed: 'Failed to set password',
    },
  },
};

export const esEs = {
  [ns]: {
    title: 'Restablecer contraseña',
    password: {
      label: 'Nueva contraseña',
      required: 'Introduzca una nueva contraseña',
    },
    password_confirmation: {
      label: 'Repita la nueva contraseña',
      required: 'Repita la nueva contraseña',
    },
    submit: 'Establecer',
    success: 'La contraseña se ha cambiado correctamente',
    error: {
      passwords_mismatch: 'Los valores indicados no coinciden',
      reset_expired: 'El tiempo para restablecer la contraseña ha expirado. Solicite de nuevo el enlace.',
      password_not_changed: 'No se pudo establecer la contraseña',
    },
  },
};

export const ptBr = {
  [ns]: {
    title: 'Redefinição de senha',
    password: {
      label: 'Nova senha',
      required: 'Digite uma nova senha',
    },
    password_confirmation: {
      label: 'Repita a nova senha',
      required: 'Repita a nova senha',
    },
    submit: 'Definir',
    success: 'A senha foi alterada com sucesso',
    error: {
      passwords_mismatch: 'Os valores informados não coincidem',
      reset_expired: 'O tempo para redefinir a senha expirou. Solicite o link novamente.',
      password_not_changed: 'Não foi possível definir a senha',
    },
  },
};
